import React from 'react'

export default function PendingProductCreated({changeView}) {
    return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Product Created</p>
            </div>
            <p>You have successfully created a product for this club.</p>
    
            <div className="send-modal-footer">
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={() => {changeView("mainPage")}}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      );
    }
